module.exports = __webpack_public_path__ + "img/mini-mobile.5457e792.png";